import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslations } from "@/hooks/useTranslations";
import heroImage from "@/assets/hero-image.webp";

const Hero = () => {
  const { t } = useTranslations();

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Fashion editorial - model in minimal black clothing"
          className="w-full h-full object-cover object-top"
          width={1920}
          height={1080}
          fetchPriority="high"
          loading="eager"
          decoding="async"
        />
        {/* Mobile-only gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-background/20 to-transparent md:hidden" />
      </div>

      {/* Content */}
      <div className="relative z-10 container h-full flex flex-col justify-end pb-16 md:pb-24">
        <div className="max-w-2xl animate-fade-in-up">
          <p className="text-sm md:text-base uppercase tracking-[0.3em] text-foreground mb-4 drop-shadow-sm">{t("hero.season")}</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-foreground mb-6 leading-none drop-shadow-md">
            UNION
            <br />
            COLLECTION
          </h1>
          <p className="text-base md:text-lg text-foreground mb-8 max-w-md font-light drop-shadow-sm">{t("hero.subtitle")}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/collection" className="w-full sm:w-auto">
              <Button variant="hero" size="lg" className="w-full sm:w-auto">
                {t("hero.shop_collection")}
              </Button>
            </Link>
            <Link to="/lookbook" className="w-full sm:w-auto">
              <Button variant="outline" size="lg" className="w-full sm:w-auto bg-background/80 backdrop-blur-sm border-foreground text-foreground hover:bg-foreground hover:text-background transition-colors duration-300">
                {t("hero.view_lookbook")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
